var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosingBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.86,277.39c-14.73,39.43-44.81,82.11-87.14,94.75-64,19.1-71.6,70.65-186.16,65.87A230.92,230.92,0,0,1,142,430.75,194.41,194.41,0,0,1,118.73,423C51.8,395.89,16.89,336.23,14,273.81c-3.82-82.11,53.46-121.24,90.69-144.15S186.79,18,299.44,21.77a224.06,224.06,0,0,1,50.92,7.44c37.91,10.26,76.44,32.95,98.84,66.12q2.52,3.75,4.82,7.64C484,153.82,484.93,223.63,464.86,277.39Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.86,277.39c-14.73,39.43-44.81,82.11-87.14,94.75-64,19.1-71.6,70.65-186.16,65.87A230.92,230.92,0,0,1,142,430.75,194.41,194.41,0,0,1,118.73,423C51.8,395.89,16.89,336.23,14,273.81c-3.82-82.11,53.46-121.24,90.69-144.15S186.79,18,299.44,21.77a224.06,224.06,0,0,1,50.92,7.44c37.91,10.26,76.44,32.95,98.84,66.12q2.52,3.75,4.82,7.64C484,153.82,484.93,223.63,464.86,277.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.32,318.54s2-9.65-1.49-14.43-9.85,0-9,6S453.32,318.54,453.32,318.54Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.72,360.85s3.06-15-2.33-22.49-15.34,0-14,9.32S437.72,360.85,437.72,360.85Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.93,385.14s-.13-15.35-6.95-21.52-15,3.17-11.75,12S431.93,385.14,431.93,385.14Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.11,399.42c-9.16.81-18.51,13-18.51,13s12.69,8.8,20.64,3.7S455.27,398.6,446.11,399.42Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.76,422.59c-13.1,1.17-26.48,18.58-26.48,18.58s18.16,12.58,29.53,5.28S459.87,421.42,446.76,422.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.58,412.51l.64,0s0-.73-.09-1.94c1.61-5.65,3.38-12.79,5.49-21.31.29-1.16.58-2.35.88-3.55,3.34,2,13,7.1,19.45,2.93,7.95-5.1,7-17.5-2.12-16.68-6.63.6-13.35,7.12-16.57,10.69,1.35-5.41,2.82-11.22,4.42-17.31.27-1,.57-2.09.89-3.2,3.2,2.9,11.11,9.1,18,6.51,8.84-3.34,10.52-15.66,1.39-16.76-6.58-.8-14.47,4.15-18.38,7,2-6.37,4.57-13.71,7.27-20.93,1.94,1.79,7.16,6,11.68,4.31,5.66-2.15,6.74-10,.88-10.76-4.26-.51-9.37,2.72-11.85,4.53,2.17-5.75,4.37-11.37,6.35-16.32,2.24,1.95,7,5.41,11.16,3.84,5.67-2.14,6.75-10,.89-10.75-3.72-.45-8.1,2-10.8,3.78,2.9-7.18,5.13-12.47,5.71-13.85,2.33-1.22,9.37-5.07,10.74-7.67a6.39,6.39,0,1,0-11.3-6c-1.32,2.5-.66,9.95-.33,12.86l-.38-.16c-.07.17-3,7-6.8,16.54l-.19.16.09.1c-2.06,5.14-4.37,11-6.64,17.08.39-2.94.85-9.27-1.75-12.86-3.45-4.78-9.84,0-9,6,.77,5.36,8.53,7.89,10.16,8.36-3,8.13-6,16.41-8,23.35l-.34.27s.07.08.2.2c-.42,1.4-.79,2.74-1.13,4-2.28,8.66-4.29,16.78-6.06,23.94-1.67,6.71-3.12,12.56-4.44,17.5-.72-5-2.42-11.77-6.42-15.4-6.82-6.17-15,3.17-11.75,12,2.5,6.78,12.12,8.74,16.5,9.29l-.75,2.42c-1,3.07-2.91,11.58-4.91,21-.74-7.12-2.95-19.14-9.57-25.12-9.75-8.83-21.48,4.53-16.8,17.21,3.92,10.64,20.11,13,25.2,13.46-2.74,13.07-5.31,26.06-5.5,27.06l1.51.3c.09-.46,9-45.6,11.53-53.38C426,414.38,426.29,413.47,426.58,412.51Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,165.74s-4.56-9.89-10.52-11.18-8.25,8-3.67,12.47S193.27,165.74,193.27,165.74Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41,214.81S200.3,199.4,191,197.39s-12.86,12.5-5.72,19.42S207.41,214.81,207.41,214.81Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.18,240.4s-10-13.08-19.64-12.82-10.53,15-2.1,19.92S218.18,240.4,218.18,240.4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,241.1c-7.13,8.17-7.14,26.25-7.14,26.25s16.27-2.79,19.64-13.66S246.36,232.92,239.22,241.1Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,260.47c-10.2,11.7-10.21,37.56-10.21,37.56s23.28-4,28.1-19.54S264.87,248.78,254.66,260.47Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,268.28l.57-.49s-.48-.62-1.32-1.59c-2.29-6.18-5.39-13.75-9.11-22.79l-1.54-3.77c4.09-1,15.41-4.48,18.16-13.34,3.37-10.87-5.37-20.77-12.5-12.6-5.16,5.91-6.59,17-7,22.69-2.35-5.75-4.86-11.94-7.43-18.47-.43-1.1-.87-2.26-1.31-3.47,4.53-.12,15.14-1.25,19.21-9.08,5.25-10.07-1.26-22-9.61-15.52-6,4.68-9.44,15.36-10.89,21-2.44-7.09-5-15.5-7.38-23.91,2.77,0,9.86-.68,12.54-5.82,3.37-6.47-.81-14.14-6.16-10-3.9,3-6.1,10-7,13.56-1.89-6.71-3.66-13.33-5.18-19.2,3.13-.15,9.34-1.06,11.81-5.8,3.36-6.47-.82-14.13-6.17-10-3.4,2.65-5.51,8.29-6.6,12.05-2.2-8.53-3.73-14.89-4.13-16.55,1.16-2.95,4.58-12,4.06-15.35-.63-4-4.11-6.38-7.79-5.26A8.56,8.56,0,0,0,181,134c.5,3.22,5.85,9.08,8,11.32l-.42.17c.05.2,2,8.46,5,19.75,0,.18-.06.3-.06.3h.14c1.58,6.1,3.44,13.06,5.42,20.1-1.56-2.84-5.25-8.66-9.73-9.63-6-1.29-8.24,8-3.66,12.46,4.1,4,12.21-.18,13.88-1.1,2.68,9.45,5.57,18.94,8.3,26.58-.07.33-.1.52-.1.52H208c.55,1.54,1.1,3,1.63,4.36,3.66,9.29,7.19,17.91,10.31,25.51,2.93,7.13,5.47,13.33,7.54,18.65-3.81-3.69-9.59-8.14-15.27-8-9.67.26-10.53,15-2.1,19.92,6.46,3.79,15.76-2.38,19.78-5.48.33.94.64,1.84.92,2.7,1.15,3.44,5,12.32,9.37,22-5.2-5.51-14.78-14-24.16-13.78-13.83.37-15.06,21.42-3,28.5,10.13,5.94,25.18-5.26,29.74-9,6.12,13.47,12.32,26.72,12.79,27.74l1.46-1c-.22-.46-21.76-46.52-24.66-55.26C232,270.35,231.67,269.34,231.29,268.28Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.65,340.91s-5-7.64-10.06-8-5.86,7.63-1.53,10.76S188.65,340.91,188.65,340.91Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.28,379.8s-7.74-11.89-15.68-12.43-9.13,11.9-2.38,16.76S206.28,379.8,206.28,379.8Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.29,399.67s-9.84-9.61-17.81-8.23-6.9,13.67.68,16.74S218.29,399.67,218.29,399.67Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,397.71c-4.92,7.63-2.74,22.59-2.74,22.59s13.13-4.28,14.6-13.68S240.7,390.08,235.79,397.71Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.91,411.87c-7,10.92-3.91,32.32-3.91,32.32s18.78-6.12,20.89-19.57S257.94,401,250.91,411.87Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.51,421.16l.41-.47s-.47-.46-1.29-1.16c-2.63-4.83-6.12-10.72-10.28-17.76l-1.74-2.93c3.26-1.31,12.21-5.57,13.41-13.24,1.48-9.4-7-16.53-11.86-8.91-3.56,5.52-3.4,14.87-3,19.62-2.64-4.47-5.47-9.29-8.38-14.38-.49-.86-1-1.77-1.51-2.72,3.74-.64,12.38-2.86,14.8-9.83,3.13-9-3.71-18.07-9.83-11.69-4.41,4.6-5.95,13.86-6.47,18.68-2.88-5.57-6-12.22-9-18.89,2.29-.37,8.08-1.75,9.67-6.34,2-5.75-2.38-11.59-6.31-7.5-2.85,3-3.83,9-4.16,12.07-2.37-5.32-4.63-10.59-6.61-15.26,2.58-.5,7.61-2,9.08-6.23,2-5.76-2.39-11.6-6.31-7.5-2.5,2.6-3.56,7.53-4,10.78-2.84-6.8-4.89-11.88-5.41-13.2.6-2.58,2.33-10.49,1.5-13.2-1-3.26-4.18-4.78-7.08-3.4a7.15,7.15,0,0,0-3.44,8.39c.8,2.6,5.94,6.81,8,8.4l-.33.19c.07.16,2.7,6.76,6.49,15.75,0,.15,0,.25,0,.25h.12c2.05,4.85,4.42,10.38,6.91,16-1.63-2.16-5.38-6.53-9.21-6.79-5.09-.34-5.85,7.64-1.52,10.76,3.87,2.79,10.08-1.63,11.35-2.6,3.36,7.51,6.9,15,10.08,21,0,.28,0,.44,0,.44l.24,0c.65,1.2,1.27,2.34,1.88,3.4,4.15,7.25,8.12,14,11.62,19.87,3.28,5.54,6.14,10.37,8.49,14.52-3.6-2.59-8.92-5.57-13.6-4.76-8,1.38-6.9,13.66.68,16.74,5.79,2.35,12.75-3.88,15.69-6.93.39.73.76,1.44,1.1,2.12,1.36,2.71,5.64,9.59,10.41,17.07-5-3.94-13.92-9.83-21.66-8.48-11.4,2-9.87,19.54,1,23.94,9.1,3.69,20.19-7.39,23.52-11,6.69,10.4,13.42,20.62,13.94,21.4l1.08-1c-.23-.36-23.63-35.87-27.09-42.75C233.37,422.79,233,422,232.51,421.16Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.75,151.19s1.95-8.89-1.38-12.76-9.55,1.19-8.73,6.46S453.75,151.19,453.75,151.19Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.45,191.06s3-13.87-2.16-19.9-14.88,1.86-13.61,10.09S438.45,191.06,438.45,191.06Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.73,213.56s-.06-13.75-6.64-18.45-14.58,4.68-11.45,12.23S432.73,213.56,432.73,213.56Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.42,224.64c-8.89,1.86-18,13.92-18,13.92s12.27,6.34,20,.79S455.3,222.79,446.42,224.64Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,245.36c-12.71,2.65-25.75,19.91-25.75,19.91s17.55,9.07,28.6,1.13S459.66,242.7,447,245.36Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.42,238.78l.62,0s0-.66-.07-1.73c1.58-5.27,3.33-11.89,5.41-19.79q.44-1.62.87-3.3c3.23,1.4,12.55,4.78,18.85.25,7.72-5.55,6.89-16.56-2-14.7-6.43,1.34-13,8-16.11,11.61,1.33-5,2.78-10.41,4.36-16.07.27-.95.56-1.95.88-3,3.08,2.21,10.73,6.81,17.39,3.64,8.58-4.08,10.26-15.34,1.42-15.21-6.37.09-14.05,5.49-17.85,8.51,1.94-6,4.49-12.86,7.13-19.68,1.88,1.37,6.92,4.53,11.31,2.44,5.5-2.61,6.58-9.83.91-9.75-4.13.06-9.1,3.58-11.51,5.51,2.12-5.43,4.28-10.74,6.22-15.43,2.17,1.49,6.77,4,10.8,2.09,5.51-2.62,6.59-9.84.91-9.76-3.6.05-7.85,2.75-10.48,4.72,2.84-6.8,5-11.82,5.59-13.13,2.26-1.38,9.11-5.7,10.45-8.2,1.62-3,.48-6.33-2.54-7.43a7.18,7.18,0,0,0-8.4,3.45c-1.28,2.4-.67,9-.37,11.58l-.37-.1c-.07.16-2.92,6.67-6.66,15.68l-.18.16.08.08c-2,4.86-4.28,10.44-6.51,16.14.39-2.68.86-8.42-1.64-11.33-3.32-3.87-9.54,1.19-8.73,6.47.74,4.72,8.24,6,9.82,6.26-3,7.66-5.83,15.45-7.87,21.92l-.32.3.18.15c-.4,1.3-.77,2.55-1.1,3.73-2.25,8-4.23,15.58-6,22.23-1.64,6.22-3.07,11.65-4.38,16.24-.67-4.39-2.29-10.27-6.15-13-6.58-4.7-14.58,4.68-11.45,12.23,2.4,5.78,11.72,6.36,16,6.32-.25.79-.5,1.54-.74,2.26-1,2.88-2.87,10.75-4.84,19.4-.69-6.3-2.79-16.81-9.17-21.37-9.42-6.73-20.85,6.69-16.37,17.5,3.76,9.07,19.44,9.18,24.38,9-2.71,12.07-5.26,24-5.45,24.95l1.46.09c.09-.42,8.94-42,11.41-49.31C426.86,240.53,427.14,239.68,427.42,238.78Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.21,50V64.25a1.2,1.2,0,0,1-1.2,1.2H126a1.19,1.19,0,0,1-1.2-1.2v-42A1.2,1.2,0,0,1,126,21h69a1.2,1.2,0,0,1,1.2,1.2V46.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.64 32.45 196.21 32.45 196.21 42.05 124.79 42.05 124.79 32.45 135.69 32.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 49.25,
    width: 32.41,
    height: 11.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 48.65,
    width: 10.8,
    height: 12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "37 309.24 18.46 309.24 18.46 372.49 20.08 369.74 21.72 372.52 21.87 372.52 23.51 369.74 25.15 372.52 25.29 372.52 26.93 369.74 28.57 372.52 28.72 372.52 30.36 369.74 32 372.52 32.14 372.52 33.78 369.74 35.42 372.52 35.57 372.52 37.2 369.74 38.84 372.52 38.99 372.52 40.63 369.74 42.27 372.52 42.41 372.52 44.05 369.74 45.69 372.52 45.84 372.52 47.48 369.74 49.12 372.52 49.26 372.52 50.9 369.74 52.54 372.52 52.69 372.52 54.33 369.74 55.97 372.52 56.11 372.52 57.75 369.74 59.39 372.52 59.51 372.52 59.51 309.24 41.63 309.24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.75,
    y1: 322.75,
    x2: 54.25,
    y2: 322.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.75,
    y1: 330.25,
    x2: 54.25,
    y2: 330.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.75,
    y1: 337.75,
    x2: 54.25,
    y2: 337.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.75,
    y1: 345.25,
    x2: 54.25,
    y2: 345.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.31,
    y1: 358.5,
    x2: 54.25,
    y2: 358.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.75,
    y1: 358.5,
    x2: 46.26,
    y2: 358.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.54,
    cy: 109.5,
    r: 13.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.54,
    cy: 109.5,
    r: 10.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.61,103.48v-.92h1.6v.92c1.39.29,2.1,1.36,2.1,3v.39h-1.85v-.52c0-.89-.35-1.23-1-1.23s-1,.34-1,1.23c0,2.57,3.83,2.69,3.83,6.25,0,1.69-.73,2.78-2.12,3.07v.9h-1.6v-.9c-1.41-.29-2.12-1.38-2.12-3.07v-.85h1.85v1c0,.89.4,1.21,1,1.21s1-.32,1-1.21c0-2.57-3.82-2.69-3.82-6.25C149.55,104.85,150.24,103.78,151.61,103.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.03,
    cy: 396.1,
    r: 13.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.03,
    cy: 396.1,
    r: 10.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.11,390.08v-.93h1.6v.93c1.39.28,2.1,1.35,2.1,3v.4H71V393c0-.89-.36-1.23-1-1.23s-1,.34-1,1.23c0,2.56,3.83,2.69,3.83,6.25,0,1.69-.73,2.78-2.12,3.06v.91h-1.6v-.91C67.7,402,67,400.94,67,399.25v-.85h1.85v1c0,.89.39,1.21,1,1.21s1-.32,1-1.21c0-2.57-3.83-2.69-3.83-6.26C67,391.45,67.74,390.38,69.11,390.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.03,
    cy: 419.1,
    r: 13.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.03,
    cy: 419.1,
    r: 10.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.11,413.08v-.93h1.6v.93c1.39.28,2.1,1.35,2.1,3v.4H39V416c0-.89-.36-1.23-1-1.23s-1,.34-1,1.23c0,2.56,3.83,2.69,3.83,6.25,0,1.69-.73,2.78-2.12,3.06v.91h-1.6v-.91C35.7,425,35,423.94,35,422.25v-.85h1.85v1c0,.89.39,1.21,1,1.21s1-.32,1-1.21c0-2.57-3.83-2.69-3.83-6.26C35,414.45,35.74,413.38,37.11,413.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.17 59.86 36.67 43.92 77.23 17.18 84.58 28.33",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "54.01 36.88 76.17 22.27 80.81 29.31",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44.61 49.27 41.77 44.95 43.25 43.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.64 56.1 49.96 64.08 43.69 40.77 90.61 28.16 96.88 51.47 82.96 55.21",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.88,
    y: 25.51,
    width: 16.81,
    height: 41.21,
    transform: "translate(96.58 -33.73) rotate(74.96)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,49.81c-3.09.83-6-.15-6.59-2.19s1.52-4.36,4.61-5.19,6,.14,6.6,2.18S74.37,49,71.27,49.81Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.99,
    y: 184.89,
    width: 14.61,
    height: 29.4,
    transform: "translate(-131.68 89.37) rotate(-46.05)",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.21,
    y: 187.12,
    width: 10.17,
    height: 24.93,
    transform: "translate(-131.68 89.37) rotate(-46.05)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9,197.92c1.4,1.35,1.81,3.19.93,4.11s-2.74.57-4.14-.78-1.81-3.18-.92-4.1S39.5,196.58,40.9,197.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.71,
    y: 182.54,
    width: 14.61,
    height: 29.4,
    transform: "translate(-96.03 50.88) rotate(-31.23)",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.93,
    y: 184.77,
    width: 10.17,
    height: 24.93,
    transform: "matrix(0.86, -0.52, 0.52, 0.86, -96.03, 50.88)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,196c1,1.66.94,3.54-.16,4.21S42,200.1,41,198.44s-.94-3.54.15-4.2S44,194.38,45,196Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.51,
    y: 180.81,
    width: 14.61,
    height: 29.4,
    transform: "translate(-26.54 8.62) rotate(-7.94)",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.73,
    y: 183.04,
    width: 10.17,
    height: 24.94,
    transform: "translate(-26.54 8.62) rotate(-7.94)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1,195.19c.27,1.92-.54,3.62-1.8,3.8s-2.51-1.24-2.78-3.16.54-3.62,1.81-3.8S50.83,193.27,51.1,195.19Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.07,
    y: 183.68,
    width: 14.61,
    height: 29.4,
    transform: "translate(47.26 -6.96) rotate(13.35)",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.29,
    y: 185.92,
    width: 10.17,
    height: 24.94,
    transform: "translate(47.26 -6.96) rotate(13.35)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,198.92c-.44,1.88-1.81,3.18-3.06,2.88s-1.88-2.06-1.43-4,1.81-3.18,3.06-2.89S56.07,197,55.62,198.92Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,279.92s-3.23,4.11-4.12,23.52S91.58,350.77,92.17,359s1.47,15.88,1.47,15.88A59.41,59.41,0,0,0,93.93,399c2.94,12.64,12,46.45,12,46.45s-7,14.7-7,15.58-3.53,2.65-3.82,5a10.49,10.49,0,0,0,0,3.53h23.22s1.47-2.06,1.47-6.77-3.23-25.87-3.23-25.87l.29-72.32V317.26l30,77.61a598.79,598.79,0,0,0,23.22,57.82c.61,1.33,4.7,12.05,9.4,15.58s9.12,4.41,9.41-.88-3.53-16.76-7.35-20-8.82-10.29-8.82-11.47S158.56,346,158.56,346l-10.24-50.77s.73-5.15-1.1-13.16-13-7.13-13-7.13l-46.75-2.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,346l-10.24-50.77s.73-5.15-1.1-13.16-13-7.13-13-7.13l-46.75-2.06-3.82,7.06s-3.23,4.11-4.12,23.52S91.58,350.77,92.17,359s1.47,15.88,1.47,15.88A59.41,59.41,0,0,0,93.93,399c1,4.16,2.61,10.62,4.37,17.41a87.78,87.78,0,0,0,18.35.34l.21-52.15V317.26l30,77.61s4,11.49,8.5,22.44c4.8.08,9.39-.44,13.59-2.65C164.24,388.81,158.56,346,158.56,346Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,462.78c0-2-.57-6.85-1.23-11.85-2.38,2.95-7.12,8.33-11.12,9.8-4.36,1.6-7.28.34-8.35-.29a2.55,2.55,0,0,0-.17.58c0,.88-3.53,2.65-3.82,5a10.49,10.49,0,0,0,0,3.53h23.22S119.8,467.49,119.8,462.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.53,447.4l-.27-.25c1.39,4.09,2.42,10-1.49,12.3-2.34,1.4-5,.29-7.25-1.54,1.74,3.68,4.19,8.29,6.95,10.36,4.71,3.53,9.12,4.41,9.41-.88S185.35,450.63,181.53,447.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68,183.49a96.54,96.54,0,0,1,1.54,9.92c.22,3.53-5.07,4.63-5.07,4.63s-15.22,4.19-15.88,7.28-13.89,45-13.89,45c-3.31-6.62-10.34-9.91-13.89-15.44a98.92,98.92,0,0,1-5.29-9,19.5,19.5,0,0,0,1.32-5.07,6.5,6.5,0,0,0-1.1-3.31s3.08-1.1,3.08-2.64-2-4.85-2.64-5.52c-2.31-2.47-6.18.89-6.18.89A17.13,17.13,0,0,1,48.21,206c2-1.55,4-3.75,3.53-4.63s-2.2-.44-5.07,2.2-6.62,6.18-6.62,6.18,1.55-3.53,2.65-6.18,3.53-2.86,3.31-4.41-3.09-.66-5.51,2.43a21.17,21.17,0,0,0-3.75,10.58c0,2.21,4.41,5.07,6.17,8.6a90.55,90.55,0,0,1,4.85,13.45c.88,3.31,6.84,18.52,8.6,24s11.69,13.23,14.77,11.24S89.23,243,89.23,243l3.07,12.77L81.73,282.71A83.09,83.09,0,0,0,121,289.55c22.49-1.55,26.24-7.5,26.24-7.5a80.19,80.19,0,0,0-3.66-14.5c-1.88-5.52-6.71-15.93-6.71-17.25s3.31-13.89,3.31-13.89,17.86,22.93,21.39,24.25,43.22-2,43.22-2a41.43,41.43,0,0,0,5.95,2.42c2.43.66,12.79,1.1,14.33.66s.66-2,.66-2,4.41.22,4.41-1.32a2.07,2.07,0,0,0-1.32-2,1.39,1.39,0,0,0,1.59-1.39c0-1.55-1.7-1.88-1.7-1.88s.66-.88-.66-1.76-9.37-4.23-9.37-4.23,4-.44,4-1.76-11.69-.89-13,0-6.62,6-6.62,6-27.78-3.09-30.21-4-8.15-2.42-8.15-2.42-14.78-37-19-41.24A22.68,22.68,0,0,0,132,197.16a48.21,48.21,0,0,1-9-2L119.65,174S111.72,183.71,102.68,183.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,247.43c-2.42-.88-8.15-2.42-8.15-2.42s-14.78-37-19-41.24A22.68,22.68,0,0,0,132,197.16a48.21,48.21,0,0,1-9-2L119.65,174s-7.93,9.7-17,9.48a96.54,96.54,0,0,1,1.54,9.92c.22,3.53-5.07,4.63-5.07,4.63s-15.22,4.19-15.88,7.28-13.89,45-13.89,45a22,22,0,0,0-4-5.46l.06.39-.91.86-9.3,8.74c.48,1.33.88,2.5,1.17,3.41,1.77,5.51,11.69,13.23,14.77,11.24S89.23,243,89.23,243l3.07,12.77L81.73,282.71A83.09,83.09,0,0,0,121,289.55c22.49-1.55,26.24-7.5,26.24-7.5a86.36,86.36,0,0,0-4.58-16.34c-2.23-5.38-5.79-14.09-5.79-15.41s3.31-13.89,3.31-13.89,17.86,22.93,21.39,24.25c1.47.55,9.25.3,17.8-.19l1.39-11.75A73,73,0,0,1,172.79,247.43Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,235.83c-5.87,2.6-14.59,6.53-20.72,9.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.14,233.06l-3.3,1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.37,
    y1: 244.65,
    x2: 105.55,
    y2: 249.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,250.3a40.06,40.06,0,0,1,3.31,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.01,
    y1: 223.02,
    x2: 143.78,
    y2: 219.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.16,
    y1: 236.41,
    x2: 142.33,
    y2: 226.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.81,
    y1: 227.21,
    x2: 82.71,
    y2: 224.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.23,
    y1: 243.02,
    x2: 84.65,
    y2: 229.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "50.42 217.44 49.76 215.9 51.08 214.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,209l-4.87,4.19a1.07,1.07,0,0,0,.34,1.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,247.21l-3.31,1.32s.66,4.41-4.85,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.69,
    y1: 253.2,
    x2: 220.2,
    y2: 251.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.8,
    y1: 256.47,
    x2: 220.86,
    y2: 254.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.71,
    y1: 259.78,
    x2: 219.76,
    y2: 258.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,250.74s0,6.39-2,9.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,195.17,119.65,174s-7.93,9.7-17,9.48a96.54,96.54,0,0,1,1.54,9.92c.12,1.92-1.4,3.12-2.8,3.82,2,4.18,7.72,15,13.6,13.38,5-1.38,7.86-9.94,9.12-15.08C123.4,195.32,123,195.17,123,195.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,180.1,119,174.78c-2.1,2.29-8.82,8.89-16.29,8.71a96.54,96.54,0,0,1,1.54,9.92c0,.05,0,.1,0,.15a10,10,0,0,0,8.6-1.22C118.28,188.43,120.1,180.1,120.1,180.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,148.17s-10.8-.67-12.57,8.6A9.47,9.47,0,0,0,86,168.23a8.43,8.43,0,0,0,2.86,7.94c4,3.53,13.68,10.36,24.48,7.94S133.4,170.66,133,164s-3.52-7.94-3.52-7.94,5.51-7.27-.89-15.87-34.39-7.72-38.8-2S92,148.17,92,148.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,155.44l-9,7.45s1.54,12.84,5.39,18,10.63,10.64,15.51,8.84,9.66-9.87,9.66-18.08-1.54-12.33-1.54-12.33S104.75,159.3,100.13,155.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,165.41s4.05-.9,5.7,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,169.16a4.52,4.52,0,0,1,5.25-2.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,164.21a5,5,0,0,1,5.55-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89,160a6.35,6.35,0,0,1,7.35.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.94,178.16s6.6,3.3,10.2-2.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,172s2.4,2,4.65-.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,163.16s1.95-3.9,3.75-1-3,8.55-3,8.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,167.21s-3.9-1.5-3.6,3S94,175.16,94,175.16Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.75,121.48V95.36a7.08,7.08,0,0,0-7.08-7.08H42.56a7.08,7.08,0,0,0-7.07,7.08v26.12a7.07,7.07,0,0,0,7.07,7.07H67.74L80.66,140l-5.5-11.45A7.07,7.07,0,0,0,81.75,121.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,95.85V94.12h3v1.73c2.6.54,3.93,2.54,3.93,5.7v.73H59.67v-1c0-1.67-.67-2.3-1.83-2.3s-1.83.63-1.83,2.3c0,4.79,7.16,5,7.16,11.68,0,3.16-1.37,5.2-4,5.73v1.7h-3v-1.7c-2.63-.53-4-2.57-4-5.73v-1.6h3.47v1.83c0,1.67.73,2.27,1.9,2.27s1.89-.6,1.89-2.27c0-4.79-7.16-5-7.16-11.68C52.34,98.42,53.64,96.42,56.21,95.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.42,
    y: 69.6,
    width: 208.1,
    height: 385.51,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.42,
    y: 69.6,
    width: 208.1,
    height: 24.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.24 69.6 222.42 322.25 222.42 412.65 419.06 69.6 367.24 69.6",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.52 227.5 427.08 225.02 301.9 446.14 305.32 455.11 430.52 455.11 430.52 227.5",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.77,145.45a2.57,2.57,0,0,0,2.57-2.57v-25.7a2.57,2.57,0,0,0-2.57-2.57,3.58,3.58,0,0,0-.48,0V66.57A16.57,16.57,0,0,0,419.71,50H237.06a16.57,16.57,0,0,0-16.58,16.57v388a16.58,16.58,0,0,0,16.58,16.58H419.71a16.58,16.58,0,0,0,16.58-16.58v-236a2.44,2.44,0,0,0,.48,0,2.57,2.57,0,0,0,2.57-2.57V190.29a2.57,2.57,0,0,0-2.57-2.57,2.44,2.44,0,0,0-.48.05V182a2.44,2.44,0,0,0,.48,0,2.57,2.57,0,0,0,2.57-2.57v-25.7a2.57,2.57,0,0,0-2.57-2.57,2.45,2.45,0,0,0-.48,0V145.4A2.44,2.44,0,0,0,436.77,145.45ZM426.69,446.14H230.08V78.6H426.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.59,
    y: 118.02,
    width: 179.87,
    height: 69.58,
    rx: 6.38,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.41,125.91V136h-.67V125.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.17,136h-.61V125.91h.87l3,8.53v-8.53h.61V136h-.74l-3.16-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.52,128.38v.84h-.63v-.88c0-1.09-.42-1.91-1.53-1.91s-1.53.82-1.53,1.91v5.25c0,1.09.42,1.89,1.53,1.89s1.53-.8,1.53-1.89v-1.2h.63v1.16c0,1.46-.63,2.56-2.18,2.56s-2.18-1.1-2.18-2.56v-5.17c0-1.46.64-2.56,2.18-2.56S325.52,126.92,325.52,128.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,128.38c0-1.47.68-2.56,2.21-2.56s2.24,1.09,2.24,2.56v5.17c0,1.47-.68,2.56-2.24,2.56s-2.21-1.09-2.21-2.56Zm.67,5.21c0,1.1.43,1.91,1.54,1.91s1.57-.81,1.57-1.91v-5.25c0-1.1-.44-1.91-1.57-1.91s-1.54.81-1.54,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,136h-.67l-2.13-8.94v9h-.6V125.91h1l2.12,8.94,2.11-8.94h.95V136h-.63v-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.82,130.59v.6h-2.76v4.22h3.32V136h-4V125.91h4v.61h-3.32v4.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.44,150.39V149h2.48v1.44c2.15.44,3.26,2.09,3.26,4.72v.6h-2.87v-.8c0-1.38-.55-1.9-1.52-1.9s-1.52.52-1.52,1.9c0,4,5.94,4.17,5.94,9.69,0,2.62-1.14,4.3-3.29,4.75v1.4h-2.48v-1.4c-2.18-.45-3.29-2.13-3.29-4.75v-1.33H283v1.52c0,1.38.61,1.88,1.58,1.88s1.57-.5,1.57-1.88c0-4-5.93-4.16-5.93-9.68C280.24,152.51,281.31,150.86,283.44,150.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12,152.62c2.35,0,2.87-1.13,3.34-2.43h2.05v19.32h-3V154.78h-2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.91,163.27v1.8c0,1.38.6,1.87,1.57,1.87s1.57-.49,1.57-1.87v-4.25c0-1.38-.6-1.91-1.57-1.91s-1.57.53-1.57,1.91v.58H302l.55-11.21h8V153h-5.27l-.25,4.61a2.9,2.9,0,0,1,2.65-1.4c2.24,0,3.37,1.57,3.37,4.41v4.31c0,3.09-1.55,4.85-4.53,4.85S302,168,302,164.88v-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,169.51v-2.92H316v2.62l-1.33,3.06h-1.24l.8-2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,155c0-3.26,1.49-5,4.64-5,3,0,4.52,1.77,4.52,4.86v.5h-2.87v-.69c0-1.38-.6-1.91-1.57-1.91s-1.68.53-1.68,2.38v3.53a2.87,2.87,0,0,1,2.81-1.71c2.24,0,3.37,1.57,3.37,4.41v3.54c0,3.09-1.63,4.85-4.61,4.85S318,168,318,164.88Zm3,6.59v3.48c0,1.38.6,1.87,1.57,1.87s1.57-.49,1.57-1.87v-3.48c0-1.38-.6-1.9-1.57-1.9S321.08,160.21,321.08,161.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,150.19v2.65l-4.47,16.67h-3L335,153h-6v-2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,169.73c-3.06,0-4.75-1.76-4.75-4.85v-1.52c0-1.85.56-3.29,1.88-4-1.27-.69-1.88-2-1.88-3.89v-.61c0-3.09,1.69-4.86,4.75-4.86s4.75,1.77,4.75,4.86v.61c0,1.9-.64,3.2-1.88,3.89,1.32.74,1.88,2.18,1.88,4v1.52C349.2,168,347.51,169.73,344.45,169.73ZM342.74,156c0,1.54.72,2,1.71,2s1.71-.5,1.71-2v-1.08c0-1.74-.74-2.21-1.71-2.21s-1.71.47-1.71,2.21ZM344.45,167c1,0,1.68-.47,1.71-2.18V163c0-1.52-.63-2.18-1.71-2.18s-1.71.66-1.71,2.18v1.79C342.74,166.5,343.48,167,344.45,167Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,166.59v2.92H351v-2.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,152.73c-1,0-1.57.53-1.57,1.91v2.07h-2.87v-1.88c0-3.09,1.55-4.86,4.53-4.86s4.52,1.77,4.52,4.86c0,6.07-6,8.33-6,11.51a1.89,1.89,0,0,0,0,.41h5.74v2.76h-8.78v-2.37c0-5.69,6-6.62,6-12.2C362.17,153.2,361.56,152.73,360.59,152.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88,155c0-3.26,1.49-5,4.64-5,3,0,4.53,1.77,4.53,4.86v.5h-2.87v-.69c0-1.38-.61-1.91-1.58-1.91s-1.68.53-1.68,2.38v3.53a2.88,2.88,0,0,1,2.82-1.71c2.23,0,3.36,1.57,3.36,4.41v3.54c0,3.09-1.63,4.85-4.61,4.85s-4.61-1.76-4.61-4.85Zm3,6.59v3.48c0,1.38.61,1.87,1.57,1.87s1.58-.49,1.58-1.87v-3.48c0-1.38-.61-1.9-1.58-1.9S369.92,160.21,369.92,161.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.9,
    y: 205.86,
    width: 181.25,
    height: 216.18,
    rx: 6.38,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,285.94H341.47V233H237.9V422H417.39a1.76,1.76,0,0,0,1.76-1.76V287.7A1.76,1.76,0,0,0,417.39,285.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.36,
    y: 347.81,
    width: 15.08,
    height: 36.43,
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.66,
    y: 324.44,
    width: 15.08,
    height: 59.8,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.95,
    y: 343.68,
    width: 15.08,
    height: 40.56,
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.25,
    y: 337.3,
    width: 15.08,
    height: 46.94,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.54,
    y: 334.75,
    width: 15.08,
    height: 49.49,
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.84,
    y: 302.44,
    width: 15.08,
    height: 81.8,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.13,
    y: 312.06,
    width: 15.08,
    height: 72.18,
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,395.32v.19h-.54v-.22c0-.92-.35-1.61-1.29-1.61s-1.29.68-1.29,1.59c0,2.11,3.13,2.14,3.13,4.53,0,1.25-.54,2.16-1.86,2.16s-1.87-.91-1.87-2.16v-.45h.54v.49c0,.92.36,1.59,1.31,1.59s1.31-.67,1.31-1.59c0-2.08-3.12-2.12-3.12-4.53,0-1.3.56-2.14,1.84-2.15S253.8,394.07,253.8,395.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.27,399.8c0,.93.35,1.64,1.3,1.64s1.3-.71,1.3-1.64v-6.57h.53v6.54c0,1.24-.52,2.19-1.84,2.19s-1.85-.95-1.85-2.19v-6.54h.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9,401.89h-.52v-8.66h.74l2.6,7.31v-7.31h.52v8.66h-.63l-2.71-7.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.29,401.88h-.57l-1.83-7.66v7.67h-.5v-8.66h.81l1.82,7.66,1.81-7.66h.81v8.66h-.54V394.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,395.35c0-1.26.58-2.19,1.89-2.19s1.92.93,1.92,2.19v4.42c0,1.27-.58,2.19-1.92,2.19s-1.89-.92-1.89-2.19Zm.57,4.46c0,.94.37,1.63,1.32,1.63s1.35-.69,1.35-1.63v-4.5c0-.94-.38-1.63-1.35-1.63s-1.32.69-1.32,1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,401.89h-.52v-8.66h.74l2.6,7.31v-7.31h.52v8.66h-.63l-2.71-7.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,401.89v-8.14h-1.76v-.52h4.09v.52h-1.76v8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,399.8c0,.93.34,1.64,1.29,1.64s1.3-.71,1.3-1.64v-6.57h.54v6.54c0,1.24-.52,2.19-1.85,2.19s-1.85-.95-1.85-2.19v-6.54h.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.47,397.24v.52H309.1v3.61H312v.52h-3.42v-8.66H312v.52H309.1v3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.72,401.89h-.79l-1.4-8.66h.56l1.29,7.89,1.27-7.85h.6l1.21,7.83,1.25-7.87h.51l-1.39,8.66h-.74l-1.16-7.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,397.24v.52h-2.36v3.61h2.84v.52H330.1v-8.66h3.41v.52h-2.84v3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,393.23c1.33,0,1.92.88,1.92,2.15v4.36c0,1.27-.59,2.15-1.92,2.15h-1.91v-8.66Zm0,8.14c1,0,1.36-.65,1.36-1.61v-4.4c0-.95-.41-1.61-1.36-1.61H335v7.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,401.89v-8.14h-1.76v-.52h4.1v.52h-1.77v8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.62,397.82v4.07h-.56v-8.66h.56v4.07h2.7v-4.07h.58v8.66h-.58v-4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,399.8c0,.93.34,1.64,1.29,1.64s1.3-.71,1.3-1.64v-6.57h.54v6.54c0,1.24-.52,2.19-1.85,2.19s-1.85-.95-1.85-2.19v-6.54h.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,397.45V398h-2.24v3.92h-.57v-8.66h3.29v.52h-2.72v3.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,393.23c1.32,0,1.85.73,1.85,2v.75c0,1-.39,1.6-1.25,1.79a1.57,1.57,0,0,1,1.25,1.77v1.35a2,2,0,0,0,.21,1h-.59a2,2,0,0,1-.19-1v-1.36c0-1.15-.63-1.47-1.62-1.47H378v3.87h-.57v-8.66Zm-.32,4.27c1,0,1.6-.28,1.6-1.45v-.81c0-.93-.36-1.49-1.3-1.49H378v3.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,393.23v8.66h-.57v-8.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,395.32v.19h-.55v-.22c0-.92-.34-1.61-1.28-1.61s-1.29.68-1.29,1.59c0,2.11,3.13,2.14,3.13,4.53,0,1.25-.55,2.16-1.87,2.16s-1.87-.91-1.87-2.16v-.45h.55v.49c0,.92.36,1.59,1.31,1.59s1.31-.67,1.31-1.59c0-2.08-3.13-2.12-3.13-4.53,0-1.3.57-2.14,1.84-2.15S402.23,394.07,402.23,395.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,400l-.44,1.92H403l1.89-8.67h.83l1.93,8.67h-.57l-.43-1.92Zm.08-.49h2.52l-1.27-5.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.54,401.89v-8.14h-1.76v-.52h4.1v.52h-1.77v8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.87,216.19v.21h-.64v-.26c0-1.06-.4-1.87-1.5-1.87s-1.5.79-1.5,1.86c0,2.46,3.65,2.5,3.65,5.29,0,1.45-.63,2.52-2.18,2.52s-2.18-1.07-2.18-2.52v-.52h.64v.56c0,1.08.42,1.86,1.53,1.86s1.53-.78,1.53-1.86c0-2.43-3.66-2.47-3.66-5.29,0-1.51.67-2.5,2.16-2.51S291.87,214.73,291.87,216.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,213.75c1.56,0,2.17,1,2.17,2.45v1.1c0,1.6-.74,2.4-2.34,2.4h-1.26v4.16H293V213.75Zm-.17,5.34c1.17,0,1.67-.52,1.67-1.75v-1.18c0-1.1-.37-1.81-1.5-1.81h-1.43v4.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.63,218.43v.6h-2.76v4.22h3.32v.61h-4V213.75h4v.6h-3.32v4.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88,223.86h-.61V213.75h.87l3,8.53v-8.53h.61v10.11H307l-3.16-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.14,213.75c1.56,0,2.24,1,2.24,2.51v5.08c0,1.49-.68,2.52-2.24,2.52h-2.23V213.75Zm0,9.5c1.13,0,1.59-.77,1.59-1.88v-5.14c0-1.11-.47-1.88-1.59-1.88h-1.54v8.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,213.75v10.11h-.67V213.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,223.86h-.61V213.75h.87l3,8.53v-8.53h.61v10.11h-.74l-3.16-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,216.22V217h-.63v-.8c0-1.08-.42-1.9-1.53-1.9s-1.54.82-1.54,1.9v5.26c0,1.08.42,1.89,1.54,1.89s1.53-.81,1.53-1.89v-2.18h-1.35v-.61h2v2.75c0,1.46-.63,2.55-2.18,2.55s-2.18-1.09-2.18-2.55v-5.17c0-1.46.64-2.56,2.18-2.56S326.25,214.76,326.25,216.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.86,216.19v.21h-.64v-.26c0-1.06-.4-1.87-1.5-1.87s-1.5.79-1.5,1.86c0,2.46,3.65,2.5,3.65,5.29,0,1.45-.63,2.52-2.18,2.52s-2.18-1.07-2.18-2.52v-.52h.64v.56c0,1.08.42,1.86,1.53,1.86s1.53-.78,1.53-1.86c0-2.43-3.66-2.47-3.66-5.29,0-1.51.67-2.5,2.16-2.51S333.86,214.73,333.86,216.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.57,221.42c0,1.08.41,1.92,1.52,1.92s1.52-.84,1.52-1.92v-7.67h.62v7.64c0,1.44-.61,2.55-2.15,2.55s-2.17-1.11-2.17-2.55v-7.64h.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76,223.84h-.66L341,214.9v9h-.59V213.75h.95l2.12,8.94,2.11-8.94h.95v10.11h-.63v-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.05,223.84h-.66l-2.14-8.94v9h-.59V213.75h.95l2.12,8.94,2.11-8.94h1v10.11h-.63v-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,221.62l-.5,2.24h-.61L357,213.73h1l2.25,10.13h-.66l-.51-2.24ZM356,221H359l-1.49-6.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35,213.75c1.54,0,2.16.85,2.16,2.28v.88a1.84,1.84,0,0,1-1.45,2.09,1.83,1.83,0,0,1,1.45,2.07v1.57a2.27,2.27,0,0,0,.25,1.22h-.69a2.34,2.34,0,0,1-.22-1.22v-1.58c0-1.35-.74-1.72-1.89-1.72H361.9v4.52h-.66V213.75Zm-.38,5c1.19,0,1.88-.33,1.88-1.69v-.95c0-1.09-.42-1.74-1.52-1.74H361.9v4.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,220l-2.27-6.22h.69l1.94,5.31,1.93-5.31h.65L369.41,220v3.89h-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,251.35h-.92l-1.63-10.11h.65l1.51,9.22,1.48-9.17h.7l1.42,9.14,1.46-9.19h.59l-1.62,10.11h-.86l-1.36-8.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,245.92v.61h-2.75v4.22h3.32v.6h-4V241.24h4v.61h-3.32v4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,245.92v.61h-2.76v4.22h3.32v.6h-4V241.24h4v.61h-3.32v4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.93,246.6l-.69,1.1v3.65h-.66V241.24h.66v5.35l3.29-5.35h.7L265.34,246l3.07,5.4h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,251.35V241.24h.66v9.51h3.18v.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,247.47l-2.27-6.23h.69l1.94,5.32,1.93-5.32h.65l-2.28,6.23v3.88h-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,261.76v-1H249v1c1.55.31,2.35,1.5,2.35,3.39v.44h-2.07V265c0-1-.4-1.37-1.09-1.37s-1.09.38-1.09,1.37c0,2.86,4.27,3,4.27,7,0,1.89-.82,3.1-2.37,3.42v1H247.2v-1c-1.57-.32-2.37-1.53-2.37-3.42v-1h2.07v1.09c0,1,.44,1.35,1.13,1.35s1.13-.36,1.13-1.35c0-2.86-4.27-3-4.27-7C244.89,263.28,245.67,262.09,247.2,261.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,272.06c0,2.34-1.07,3.61-3.34,3.61s-3.25-1.27-3.25-3.49v-.36h2.06v.5c0,1,.44,1.37,1.13,1.37S257,273.31,257,272v-2.54a2.07,2.07,0,0,1-2,1.23c-1.61,0-2.42-1.13-2.42-3.18V265c0-2.22,1.17-3.49,3.31-3.49s3.32,1.27,3.32,3.49ZM257,267.31v-2.5c0-1-.43-1.35-1.13-1.35s-1.13.36-1.13,1.35v2.5c0,1,.44,1.37,1.13,1.37S257,268.31,257,267.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,265c0-2.22,1.17-3.49,3.31-3.49s3.32,1.27,3.32,3.49v7.23c0,2.22-1.17,3.49-3.32,3.49s-3.31-1.27-3.31-3.49Zm2.18,7.37c0,1,.44,1.37,1.13,1.37s1.14-.38,1.14-1.37v-7.51c0-1-.44-1.37-1.14-1.37s-1.13.38-1.13,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36,265c0-2.22,1.17-3.49,3.32-3.49S275,262.73,275,265v7.23c0,2.22-1.17,3.49-3.31,3.49s-3.32-1.27-3.32-3.49Zm2.18,7.37c0,1,.44,1.37,1.14,1.37s1.13-.38,1.13-1.37v-7.51c0-1-.44-1.37-1.13-1.37s-1.14.38-1.14,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,273.41v2.1H276.4v-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.23,275.67c-2.2,0-3.41-1.27-3.41-3.49v-1.09a3,3,0,0,1,1.35-2.9,2.88,2.88,0,0,1-1.35-2.8V265c0-2.22,1.21-3.49,3.41-3.49a3.13,3.13,0,0,1,3.42,3.49v.44a2.93,2.93,0,0,1-1.35,2.8,3.06,3.06,0,0,1,1.35,2.9v1.09A3.13,3.13,0,0,1,283.23,275.67ZM282,265.81c0,1.11.52,1.47,1.23,1.47s1.23-.36,1.23-1.47V265c0-1.25-.53-1.59-1.23-1.59S282,263.78,282,265Zm1.23,7.88c.7,0,1.21-.34,1.23-1.57v-1.29c0-1.09-.46-1.57-1.23-1.57s-1.23.48-1.23,1.57v1.29C282,273.35,282.54,273.69,283.23,273.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37,272.06c0,2.34-1.07,3.61-3.34,3.61s-3.25-1.27-3.25-3.49v-.36h2.06v.5c0,1,.44,1.37,1.13,1.37s1.21-.38,1.21-1.71v-2.54a2.07,2.07,0,0,1-2,1.23c-1.61,0-2.42-1.13-2.42-3.18V265c0-2.22,1.17-3.49,3.31-3.49s3.32,1.27,3.32,3.49Zm-2.19-4.75v-2.5c0-1-.43-1.35-1.13-1.35s-1.13.36-1.13,1.35v2.5c0,1,.44,1.37,1.13,1.37S292.18,268.31,292.18,267.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.61,251.34H352l-2.14-8.94v8.95h-.59V241.24h.95l2.13,8.94,2.1-8.94h1v10.11h-.64v-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47,243.71c0-1.47.67-2.55,2.21-2.55s2.23,1.08,2.23,2.55v5.17c0,1.48-.67,2.56-2.23,2.56s-2.21-1.08-2.21-2.56Zm.66,5.22c0,1.09.43,1.9,1.55,1.9s1.57-.81,1.57-1.9v-5.26c0-1.1-.45-1.91-1.57-1.91s-1.55.81-1.55,1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,251.35H362V241.24h.87l3,8.54v-8.54h.6v10.11h-.73l-3.17-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.36,251.35v-9.5h-2.05v-.61h4.78v.61H370v9.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.57,246.6v4.75h-.66V241.24h.66V246h3.15v-4.75h.68v10.11h-.68V246.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.55,251.35V241.24h.67v9.51h3.17v.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,247.47l-2.27-6.23h.7l1.93,5.32,1.94-5.32h.65l-2.28,6.23v3.88h-.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,261.76v-1h1.79v1c1.55.31,2.34,1.5,2.34,3.39v.44h-2.07V265c0-1-.39-1.37-1.09-1.37s-1.09.38-1.09,1.37c0,2.86,4.27,3,4.27,7,0,1.89-.81,3.1-2.36,3.42v1h-1.79v-1c-1.57-.32-2.36-1.53-2.36-3.42v-1h2.06v1.09c0,1,.44,1.35,1.13,1.35s1.13-.36,1.13-1.35c0-2.86-4.26-3-4.26-7C349.38,263.28,350.15,262.09,351.68,261.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,263.36a2.16,2.16,0,0,0,2.4-1.74h1.47v13.89h-2.18v-10.6h-1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,265c0-2.22,1.17-3.49,3.32-3.49s3.31,1.27,3.31,3.49v7.23c0,2.22-1.17,3.49-3.31,3.49S365,274.4,365,272.18Zm2.18,7.37c0,1,.44,1.37,1.14,1.37s1.13-.38,1.13-1.37v-7.51c0-1-.44-1.37-1.13-1.37s-1.14.38-1.14,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,275.51v-2.1h2.11v1.89l-1,2.2h-.89l.58-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,263.44c-.69,0-1.13.38-1.13,1.37v1.49h-2.07V265c0-2.22,1.12-3.49,3.26-3.49s3.26,1.27,3.26,3.49c0,4.37-4.35,6-4.35,8.28a1.51,1.51,0,0,0,0,.3H383v2h-6.32v-1.7c0-4.09,4.33-4.77,4.33-8.78C381,263.78,380.61,263.44,379.91,263.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.4,265c0-2.22,1.17-3.49,3.31-3.49S391,262.73,391,265v7.23c0,2.22-1.17,3.49-3.32,3.49s-3.31-1.27-3.31-3.49Zm2.18,7.37c0,1,.44,1.37,1.13,1.37s1.13-.38,1.13-1.37v-7.51c0-1-.43-1.37-1.13-1.37s-1.13.38-1.13,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,265c0-2.22,1.17-3.49,3.31-3.49s3.32,1.27,3.32,3.49v7.23c0,2.22-1.17,3.49-3.32,3.49s-3.31-1.27-3.31-3.49Zm2.18,7.37c0,1,.44,1.37,1.13,1.37s1.14-.38,1.14-1.37v-7.51c0-1-.44-1.37-1.14-1.37s-1.13.38-1.13,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4,273.41v2.1h-2.1v-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,271v1.29c0,1,.43,1.35,1.13,1.35s1.13-.36,1.13-1.35v-3.06c0-1-.44-1.37-1.13-1.37s-1.13.38-1.13,1.37v.42h-2.07l.4-8.06h5.76v2h-3.79l-.18,3.32a2.07,2.07,0,0,1,1.9-1c1.61,0,2.43,1.14,2.43,3.18v3.1c0,2.22-1.12,3.49-3.26,3.49s-3.26-1.27-3.26-3.49V271Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 454,
    y1: 471.2,
    x2: 485,
    y2: 471.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 471.2,
    x2: 445,
    y2: 471.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosingBox);
export default __webpack_public_path__ + "static/media/closing-box.ea536c9bc4335352d7ab787e3ad3df99.svg";
export { ForwardRef as ReactComponent };